import { Box, Typography } from "@mui/material";

export function IOSStatusBar() {
  return (
    <Box
      sx={{
        height: 28,
        px: 4,
        pt: 0.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        color: "#000",
        flexShrink: 0,
      }}
    >
      <Typography fontSize={12} fontWeight={600}>
        9:41
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
        <Box
          sx={{
            display: "flex",
            gap: "2px",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "flex-end",
          }}
        >
          {[1, 2, 3, 4].map((i) => (
            <Box
              key={i}
              sx={{
                width: 3,
                height: 6 + i * 2,
                bgcolor: "#000",
                borderRadius: 0.5,
                opacity: i < 4 ? 0.6 : 1,
              }}
            />
          ))}
        </Box>

        <Box
          sx={{
            width: 14,
            height: 10,
            border: "1.5px solid #000",
            borderRadius: 2,
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 1,
              left: 1,
              width: "70%",
              height: "70%",
              bgcolor: "#000",
              borderRadius: 1,
            }}
          />
          <Box
            sx={{
              position: "absolute",
              right: -3,
              top: 3,
              width: 2,
              height: 4,
              bgcolor: "#000",
              borderRadius: 1,
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
